// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.deno/css-loader@6.11.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles__iframe___mUe2m{border:none;background-color:#fff}.styles__iframe___mUe2m pre{color:#fff !important}", "",{"version":3,"sources":["webpack://./src/components/Iframe/styles.scss"],"names":[],"mappings":"AAAA,wBACE,WAAA,CACA,qBAAA,CAGF,4BACE,qBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iframe": "styles__iframe___mUe2m"
};
export default ___CSS_LOADER_EXPORT___;
